/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import TrackingTemplate from '@bingads-webui-component-legacy/upgraded-url/view/trackingTemplate';
import UrlTestTool from '@bingads-webui-component-legacy/upgraded-url/view/urlTestTool';
import * as upgradeUrl from '@bingads-webui-campaign/upgrade-url';
import tmpl from '@bingads-webui-component-legacy/upgraded-url/template/advancedSettingsUrlOptions.pug';
import ViewModel from '@bingads-webui-component-legacy/upgraded-url/viewmodel/advancedSettingsUrlOptions';
import config from '@bingads-webui-component-legacy/config/index';
import * as testUurlService from '@bingads-webui-component-legacy/upgraded-url/service/testUurl';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');
var AdvancedSettingsUrlOptions = Backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    _.defaults(this.options, {
      urlOptionsTemplate: tmpl,
      smallContainer: false,
      isVisible: true,
      isExpanded: false,
      editMode: true,
      hideTitle: false,
      placeholderEnabled: false,
      isForVNext: false,
      popupHelpKeyAdTrackTemplate: 'pop_BA_NewCampaignCreate_Ad_TrackTemplate',
      popupHelpKeyAdParameters: 'pop_BA_NewCampaignCreate_Ad_Parameters',
      popupHelpKeyFinalURLSuffix: 'pop_BA_NewAdCreate_FinalURLSuffix',
      isNewUI: false,
      withRealTimeUpdates: false
    });
    var entityType = !this.options.entityType ? '' : this.options.entityType.toLowerCase();
    var permissions = config.get('Permissions') || ({});
    if (entityType === 'campaign' || entityType === 'adgroup' || entityType === 'keyword' || entityType === 'ad' || entityType === 'audience') {
      this.options.isFinalURLSuffixEnabled = true;
    } else if (entityType === 'imageadextension' || entityType === 'sitelink2adextension') {
      this.options.isFinalURLSuffixEnabled = permissions.IsFinalURLSuffixPhase3Enabled;
    }
    this.ko_model = new ViewModel(this.options);
    this.showUurlTestTool = options.showUurlTestTool;
    this.ko_model.showUurlTestTool = this.showUurlTestTool;
    this.logCustomParamsChange = _.once(function () {
      this.logActivity('custom parameter change');
    }, this);
  },
  events: {
    'click .link.expander': 'expand',
    'click .link.expanded': 'collapse',
    'show.bs.collapse': 'showSettings',
    'hide.bs.collapse': 'hideSettings',
    'change input.custom-param__value-field, input.custom-param__key-field': 'customParamsChanged'
  },
  showSettings: function (e) {
    var sectionName = $(e.target).data('section');
    if (sectionName === 'TrackingTemplate') {
      this.ko_model.isTrackingTemplateSettingsExpanded(true);
      if (this.options.isNewUI) {
        this.$el.find('.trackingtemplate.bedded-icon-marker.spritedimagealign').addClass('expandedImage').removeClass('expanderImage');
      }
    }
    if (sectionName === 'FinalUrlSuffix') {
      this.ko_model.isFinalUrlSuffixSettingsExpanded(true);
      if (this.options.isNewUI) {
        this.$el.find('.finalurlsuffix.bedded-icon-marker.spritedimagealign').addClass('expandedImage').removeClass('expanderImage');
      }
    }
    if (sectionName === 'UrlCustomParameters') {
      this.ko_model.isUrlCustomParametersSettingsExpanded(true);
      if (this.options.isNewUI) {
        this.$el.find('.customparameter.bedded-icon-marker.spritedimagealign').addClass('expandedImage').removeClass('expanderImage');
      }
    }
  },
  hideSettings: function (e) {
    var sectionName = $(e.target).data('section');
    if (sectionName === 'TrackingTemplate') {
      this.ko_model.isTrackingTemplateSettingsExpanded(false);
      this.ko_model.trackingTemplate(this.trackingTemplate.ko_model.trackingTemplate());
      if (this.options.isNewUI) {
        this.$el.find('.trackingtemplate.bedded-icon-marker.spritedimagealign').addClass('expanderImage').removeClass('expandedImage');
      }
    }
    if (sectionName === 'FinalUrlSuffix') {
      this.ko_model.isFinalUrlSuffixSettingsExpanded(false);
      this.ko_model.finalUrlSuffix(this.finalUrlSuffix.getFinalUrlSuffix());
      if (this.options.isNewUI) {
        this.$el.find('.finalurlsuffix.bedded-icon-marker.spritedimagealign').addClass('expanderImage').removeClass('expandedImage');
      }
    }
    if (sectionName === 'UrlCustomParameters') {
      this.ko_model.isUrlCustomParametersSettingsExpanded(false);
      this.showCustomParamsPreview();
      if (this.options.isNewUI) {
        this.$el.find('.customparameter.bedded-icon-marker.spritedimagealign').addClass('expanderImage').removeClass('expandedImage');
      }
    }
  },
  logActivity: function (message) {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal(message, 'url options');
    }
  },
  customParamsChanged: function () {
    this.logCustomParamsChange();
  },
  render: function () {
    var $innerEl = $(this.options.urlOptionsTemplate({
      i18n: i18n,
      isVisible: this.options.isVisible,
      isExpanded: this.options.isExpanded,
      smallContainer: this.options.smallContainer,
      editMode: this.options.editMode,
      hideTitle: this.options.hideTitle,
      popupHelpKeyAdTrackTemplate: this.options.popupHelpKeyAdTrackTemplate,
      popupHelpKeyAdParameters: this.options.popupHelpKeyAdParameters,
      popupHelpKeyFinalURLSuffix: this.options.popupHelpKeyFinalURLSuffix,
      isNewUI: this.options.isNewUI
    })), $trackingTemplate = $innerEl.find('.tracking-template'), $customParams = $innerEl.find('.custom-parameters'), $urlTestTool = $innerEl.find('.uurl-test-tool__container');
    this.$el.html($innerEl);
    ko.applyBindings(this.ko_model, this.el);
    this.trackingTemplate = new TrackingTemplate(_.extend({}, this.options, {
      el: $trackingTemplate
    })).render();
    this.trackingTemplate.on('templateChanged', (function () {
      this.triggerChangeEvent();
      this.logActivity('tracking template change');
    }).bind(this));
    this.ko_model.trackingTemplate(this.trackingTemplate.ko_model.trackingTemplate());
    var permissions = config.get('Permissions') || ({});
    this.customParams = new upgradeUrl.CustomParametersView(_.extend({}, this.options, {
      permissions: permissions,
      i18n: i18n
    })).render();
    this.customParams.on('change:customParameters', (function () {
      this.triggerChangeEvent();
    }).bind(this));
    $customParams.html(this.customParams.$el);
    this.showCustomParamsPreview();
    if (this.options.isFinalURLSuffixEnabled) {
      var $finalUrlSuffix = $innerEl.find('.final-url-suffix');
      this.finalUrlSuffix = new upgradeUrl.FinalUrlSuffixView(_.chain({}).extend(this.options, {
        i18n: i18n,
        showPlaceholder: true
      }).omit('template').value()).render();
      this.finalUrlSuffix.on('finalUrlSuffix:updated', (function () {
        this.triggerChangeEvent();
        this.logActivity('final url suffix change');
      }).bind(this));
      $finalUrlSuffix.html(this.finalUrlSuffix.$el);
      this.ko_model.finalUrlSuffix(this.finalUrlSuffix.getFinalUrlSuffix());
    }
    if (this.showUurlTestTool) {
      this.urlTestTool = new UrlTestTool({
        isForVNext: this.options.isForVNext || this.options.isNewUI
      });
      this.urlTestTool.on('testUurl', (function (fn, originalView) {
        if (this.options.entityType === 'Ad') {
          this.trigger('testUurl', fn, originalView);
          return;
        }
        if (!this.trackingTemplate.isValid() || !this.customParams.isValid()) {
          fn.call(originalView, null);
          return;
        }
        var testUurl = testUurlService.testUurl;
        var uurlLevels = testUurlService.uurlLevels;
        originalView.isInline = false;
        if (this.options.entityType.toLowerCase() === uurlLevels.Campaign.toLowerCase()) {
          originalView.level = uurlLevels.Campaign;
        } else if (this.options.entityType.toLowerCase() === uurlLevels.AdGroup.toLowerCase()) {
          originalView.level = uurlLevels.AdGroup;
        }
        var params = this.toObject();
        var context = {
          customerId: _.result(config.get('CurrentCustomer'), 'Id'),
          userId: _.result(config.get('CurrentUser'), 'Id'),
          accountId: _.result(config.get('CurrentAccount'), 'Id'),
          campaignId: _.result(config.get('CurrentCampaign'), 'Id') || this.options.campaignId || 0
        };
        if (originalView.level === uurlLevels.Campaign) {
          context.entityId = context.campaignid;
        } else if (originalView.level === uurlLevels.AdGroup) {
          context.adGroupId = _.result(config.get('CurrentAdGroup'), 'Id') || this.options.adGroupId || 0;
          context.entityId = context.adGroupId;
        }
        var options = {
          apiInLog: 'advancedSettingsUrlOptions/uurlTest'
        };
        testUurl(fn, originalView, params, context, options);
      }).bind(this));
      $urlTestTool.html(this.urlTestTool.render().$el);
    }
    this.triggerChangeEvent();
    return this;
  },
  showCustomParamsPreview: function () {
    this.ko_model.parameters(_.map(this.customParams.getValues(true), function (p) {
      return '{_' + p.Key + '}=' + p.Value;
    }).join('; '));
  },
  remove: function () {
    ko.cleanNode(this.el);
    return this;
  },
  handleApiErrors: function (errors) {
    if (!_.isEmpty(errors.TrackingUrlTemplate)) {
      this.trackingTemplate.ko_model.trackingTemplateErrors(errors.TrackingUrlTemplate);
    }
    if (!_.isEmpty(errors.UrlCustomParameters)) {
      this.customParams.viewModel.parametersError(errors.UrlCustomParameters);
    }
    if (!_.isEmpty(errors.FinalUrlSuffix)) {
      this.finalUrlSuffix.viewModel.externalErrors(errors.FinalUrlSuffix);
    }
  },
  clearApiErrors: function () {
    this.trackingTemplate.ko_model.trackingTemplateErrors([]);
    this.customParams.viewModel.parametersError([]);
    if (this.options.isFinalURLSuffixEnabled) {
      this.finalUrlSuffix.viewModel.externalErrors([]);
    }
  },
  triggerChangeEvent: function () {
    if (this.options.withRealTimeUpdates) {
      this.trigger('change', this.toObject(), this.isValid());
    }
  },
  toObject: function () {
    return this.options.isFinalURLSuffixEnabled ? {
      'UrlCustomParameters': this.getUrlCustomParameters(true),
      'TrackingUrlTemplate': this.getTrackingTemplate(),
      'FinalUrlSuffix': this.getFinalUrlSuffix()
    } : {
      'UrlCustomParameters': this.getUrlCustomParameters(true),
      'TrackingUrlTemplate': this.getTrackingTemplate()
    };
  },
  expandSettingsWithValidateErrors: function () {
    this.expandSettings(!this.trackingTemplate.isValid(), !this.customParams.isValid(), this.options.isFinalURLSuffixEnabled && !this.finalUrlSuffix.isValid());
  },
  expandSettingsWithApiErrors: function (trackingTemplateHasError, customParamsHasError, finalUrlSuffixHasError) {
    this.expandSettings(trackingTemplateHasError, customParamsHasError, finalUrlSuffixHasError);
  },
  expandSettings: function (expandTrackingTemplate, expandUrlParams, expandFinalUrlSuffix) {
    if (expandTrackingTemplate) {
      this.$('#trackingTemplateSettings').collapse('show');
    }
    if (expandUrlParams) {
      this.$('#customParametersSettings').collapse('show');
    }
    if (expandFinalUrlSuffix) {
      this.$('#finalUrlSuffixSettings').collapse('show');
    }
  },
  getUrlCustomParameters: function (isFlatten) {
    var list = [];
    _.each(this.customParams.viewModel.parameters(), function (p) {
      var key = p.key();
      if (key) {
        var item = {};
        var val = p.val();
        if (val === undefined) {
          val = '';
        }
        val = val.replace(/\\/g, '\\\\').replace(/;/g, '\\;');
        if (isFlatten) {
          item.Key = key;
          item.Value = val;
        } else {
          item[key] = val;
        }
        list.push(item);
      }
    });
    return list;
  },
  getTrackingTemplate: function () {
    return this.trackingTemplate.ko_model.trackingTemplate();
  },
  getFinalUrlSuffix: function () {
    return this.finalUrlSuffix.getFinalUrlSuffix();
  },
  expand: function () {
    this.$el.find('.link.expander').addClass('expanded').removeClass('expander');
    this.$el.find('.embedded-icon-marker').addClass('expandedImage').removeClass('expanderImage');
    this.ko_model.isExpanded(true);
    this.ko_model.editMode(true);
    this.trackingTemplate.setEditMode(true);
    this.options.isFinalURLSuffixEnabled && this.finalUrlSuffix.setEditMode(true);
    this.customParams.setEditMode(true);
    this.logActivity('url options toggle: true');
  },
  collapse: function () {
    this.$el.find('.link.expanded').addClass('expander').removeClass('expanded');
    this.$el.find('.embedded-icon-marker').removeClass('expandedImage').addClass('expanderImage');
    this.trackingTemplate.setEditMode(false);
    this.options.isFinalURLSuffixEnabled && this.finalUrlSuffix.setEditMode(false);
    this.customParams.setEditMode(false);
    this.ko_model.editMode(false);
    this.ko_model.isExpanded(false);
    this.logActivity('url options toggle: false');
  },
  validate: function () {
    return this.isValid();
  },
  isValid: function () {
    return this.trackingTemplate.isValid() && this.customParams.isValid() && (!this.options.isFinalURLSuffixEnabled || this.finalUrlSuffix.isValid());
  }
});
export default AdvancedSettingsUrlOptions;

